import React from "react";
import "./FloatingButton.scss";

const FloatingButton = ({ onClick }) => {
  return (
    <div className="floating-button">
      <button className="floating-button-link" onClick={onClick}>
        <img
          src="https://i.imgur.com/X4Q4cU0.png"
          alt="立即免費諮詢"
          className="floating-icon"
        />
        <span className="floating-text">立即免費諮詢</span>
      </button>
    </div>
  );
};

export default FloatingButton;
